import request from '@/utils/request'
import qs from 'qs'
import axios from 'axios'

//用户分页查询
export function getAllUserList(data) {
  return request({
    url: `/srm-sys-server/api/common/user/getAllUserList`,
    method: 'post',
    data: data
  })
}
//新增用户
export function addUsers(data) {
  return request({
    url: `/srm-sys-server/api/common/user/addUsers`,
    method: 'post',
    data: data
  })
}
//冻结用户
export function freezeUsers(data) {
  return request({
    url: `/srm-sys-server/api/common/user/freezeUsers`,
    method: 'post',
    data: data
  })
}
//解结用户
export function unfreezeUsers(data) {
  return request({
    url: `/srm-sys-server/api/common/user/unfreezeUsers`,
    method: 'post',
    data: data
  })
}
//修改密码
export function updatePassword(oldPassword,newPassword) {
  return request({
    url: `/srm-sys-server/api/common/login/updatePassword`,
    method: 'post',
    params: {
      oldPassword: oldPassword,
      newPassword: newPassword
    }
  })
}
//修改用户
export function editUser(data) {
  return request({
    url: `/srm-sys-server/api/common/user/editUser`,
    method: 'post',
    data: data
  })
}

//重置密码
export function resetPassword(data) {
  return request({
    url: `/srm-sys-server/api/common/user/resetPassword`,
    method: 'post',
    data: data
  })
}
export function importOrganizationTemplate(data) {
  return `/srm-sys-server/api/common/file/downloadTemplate?templateName=sys_user_info`
}
//导出
export function exportUsersInfo(data){
  window.open(
    "/srm-sys-server/api/common/user/exportUsersInfo?" + qs.stringify(data));
}
//导入
export function importUsersInfo(data) {
  return request({
    headers: {
      'Content-Type': 'multipart/form-data',//设置请求头请求格式为JSON
    },
    url: "/srm-sys-server/api/common/user/importUsersInfo",
    method: "post",
    data:  data
  });
}



// WEBPACK FOOTER //
// ./src/modules/sys/api/users.js